import domUtils from 'util/dom-utils'
import msg from 'services/msg'
import { TTDAT_PARAM_NAME } from 'util/turnto-utils'
import confirmMsgFlows from './confirmation-message-flows'
import reviewFlows from './review-flows'
import qaFlows from './qa-flows'
import srFlows from './seller-rating-flows'
import tokenService from 'services/token-service'
import { ERROR_PARAM, TOKEN_PARAM_NAME, TurnToFlow } from './email-flows-common'

// This checks to see if the user reloaded the page.  The interpretation of "reload" is different
// depending on the browser. All will treat the reload/refresh icon click as a realod as well as
// the key command for reload.  What is treated differently is the user clicking in the address
// bar and hitting the enter key.  Chrome treats it as a reload, but most other browsers do not.
function isReload() {
  // for old iOS 7.  Can't support because window.performance is not present.
  if (!window.performance) {
    return false
  }
  if (typeof window.performance['getEntriesByType'] === 'function') {
    // pnt - PerformanceNavigationTiming interface
    const pnt = window.performance.getEntriesByType('navigation')
      .find(entry => !!entry['type']) as PerformanceNavigationTiming
    if (pnt) {
      return pnt.type !== 'navigate'
    }
  }
  // for the case where the PerformanceNavigationTiming interface is not present, try the
  // deprecated PerformanceNavigation interface
  const pn = window.performance['navigation']
  return !pn || pn.type === undefined ? false : pn.type !== 0
}

export function processTurntoflow(turntoflow: TurnToFlow, params: URLSearchParams): void {
  if (isReload()) {
    return
  }
  const ttdat = params.get(TTDAT_PARAM_NAME)
  // if confirmation token is passed, login the user
  if (params.get(TOKEN_PARAM_NAME) && ttdat) {
    tokenService.loginUser(params.get(TOKEN_PARAM_NAME), ttdat)
  }
  domUtils.onDomReady().then(() => {
    const errCode = params.get(ERROR_PARAM)
    if (errCode && errCode !== '1101') {
      import(/* webpackChunkName: 'standalone-popover' */ 'widgets/standalone-popover/standalone-popover-loader').then((popoverLoader) => {
        popoverLoader.default.load({ message: msg(`flowError.${errCode}`), type: 'error' })
      })
      // no need to proceed to any other flows
      return
    }
    const turnToConfig = window.turnToConfig || {}
    confirmMsgFlows.process(turntoflow, params)
    if (!turnToConfig.skipReviewEmailCheck) {
      reviewFlows.process(turntoflow, params)
    }
    if (!turnToConfig.skipQaEmailCheck) {
      qaFlows.process(turntoflow, params)
    }
    srFlows.process(turntoflow, params)
  }).catch(() => {})
}
